import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-[#B8A99A]/20 last:border-b-0" data-id="element-32">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left gap-4" aria-expanded={isOpen} data-id="element-33">
        <span className="font-medium text-[#2C2825] text-[15px] md:text-base" data-id="element-34">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-[#B8A99A] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-35" />
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0,
      opacity: isOpen ? 1 : 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="overflow-hidden" data-id="element-36">
        <p className="pb-5 text-[#2C2825]/65 text-sm leading-relaxed pr-8" data-id="element-37">
          {answer}
        </p>
      </motion.div>
    </div>;
}
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full px-5 py-16 md:py-24 bg-[#F5F0EA]" data-id="element-38">
      <div className="max-w-2xl mx-auto" data-id="element-39">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-10 text-center" data-id="element-40">
          Preguntas frecuentes
        </motion.h2>

        <motion.div {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.05
      }} className="bg-white rounded-xl p-6 md:p-8 border border-[#B8A99A]/15" data-id="element-41">
          <FAQItem question="¿En qué formato viene?" answer="Todo en PDF, optimizado para leer en móvil, tablet u ordenador. Las plantillas están diseñadas para imprimir en A4." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-42" />
          <FAQItem question="¿Cuándo recibo el material?" answer="Al instante. Nada más completar la compra, recibes un email con el enlace de descarga. Si no lo ves en 5 minutos, revisa Promociones o Spam." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-43" />
          <FAQItem question="¿Necesito comprar productos específicos?" answer="No. La guía te explica qué ingredientes buscar según tu tipo de ojera, pero puedes usar productos que ya tengas en casa." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-44" />
          <FAQItem question="¿Funciona para cualquier edad?" answer="Sí. El sistema identifica tu tipo de ojera independientemente de tu edad. La rutina se adapta a tu situación específica." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-45" />
          <FAQItem question="¿Y si no sé identificar mi tipo de ojera?" answer="El test visual incluye fotos de referencia y preguntas guiadas. Está diseñado para que cualquier persona pueda hacerlo sin conocimientos previos." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-46" />
          <FAQItem question="¿Puedo compartirlo con alguien?" answer="La licencia es personal, pero cada persona necesita hacer su propio test para obtener su rutina personalizada." isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-47" />
        </motion.div>
      </div>
    </section>;
}